import { entityReport, KeyValue } from '@api';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

/**
 * @deprecated
 */
export function fetchKeyValues(entityTag: string, signal?: AbortSignal) {
  return wretchRequest<KeyValue[]>(
    entityReport.getEntityKeyValues.path(entityTag),
    {
      schema: entityReport.getEntityKeyValues.schema,
      signal,
    }
  );
}

export function fetchKeyValuesV3(entityTag: string, signal?: AbortSignal) {
  return wretchRequest<KeyValue[]>(
    entityReport.getEntityKeyValuesV3.path(entityTag),
    {
      schema: entityReport.getEntityKeyValuesV3.schema,
      signal,
    }
  );
}
